import Vue from 'vue';
import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';

// Vue.use(VueRouter);
Vue.prototype.$api_prefix = '/api';
Vue.prototype.$message = Message;
// create an axios instance
const service = axios.create({
  baseURL: Vue.prototype.$api_prefix, // api的base_url
  method: 'get',
  params: {},
  timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(config => {
  if (store.getters.getToken !== '') {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['Authorization'] = store.getters.getToken; // getToken();
  } else {
    if (config.url == '/user/login' || config.url.indexOf('/fileUpload/list')!=-1) {
      // window.location = 'login';
    }else{
      window.location = 'login';
    }
  }
  return config;
}, error => {
  window.console.log(error); // for debug
  Promise.reject(error);
});

// respone interceptor
service.interceptors.response.use(
    response => {
      if (response.data.code === 403) {
        // Vue.prototype.$router.push('/login');
        Vue.prototype.$message({
          type: 'error',
          message: '认证失效，请重新登录!',
          onClose: function () {
            window.location = 'login';
          }
        });
        // router.push('/login');
        return false;
      }
      return response;
      // let success = response.data.success;
      // if (success === true) {
      //   return response;
      // } else {
      //   Vue.prototype.$message({
      //     type: 'error',
      //     message: '请求失败! 提示信息：' + response.data.message
      //   });
      //   return response;
      // }
    },
    error => {
      if (error.response.status === 403) {
        // Vue.prototype.$router.push('/login');
        Vue.prototype.$message({
          type: 'error',
          message: '认证失效，请重新登录!',
          onClose: function () {
            window.location = 'login';
          }
        });
        // router.push('/login');
        return false;
      }
      window.console.log('err' + error); // for debug
      Vue.prototype.$message({
        type: 'error',
        message: '服务器暂时无法连接，请稍后再试!'
      });
      // window.location = 'login';
      return Promise.reject(error);
    });

export default service;
